import type { MerchantContextSummary } from "@/features/chat/merchantContextSchemas";

export function resolveMerchantAgencyName(
  context: Pick<MerchantContextSummary, "agencies" | "organizationId" | "organizationName"> | undefined,
  organizationId: string,
  organizationType: "agency" | "customer" | "system" | undefined,
  currentOrganizationName?: string,
): string | undefined {
  if (!organizationId || !organizationType) return undefined;

  if (organizationType === "agency") {
    const ownName = context?.organizationId === organizationId
      ? context.organizationName?.trim() || currentOrganizationName
      : currentOrganizationName;
    return ownName?.trim() || undefined;
  }

  if (organizationType !== "customer" || context?.organizationId !== organizationId) {
    return undefined;
  }

  const seen = new Set<string>();
  const names = context.agencies.flatMap((agency) => {
    if (seen.has(agency.organizationId)) return [];
    seen.add(agency.organizationId);
    return agency.name.trim() ? [agency.name.trim()] : [];
  });
  return names.length ? names.join(" · ") : undefined;
}
